import { render, staticRenderFns } from "./SalaryImport.vue?vue&type=template&id=4155a452&scoped=true"
import script from "./SalaryImport.vue?vue&type=script&lang=js"
export * from "./SalaryImport.vue?vue&type=script&lang=js"
import style0 from "./SalaryImport.vue?vue&type=style&index=0&id=4155a452&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4155a452",
  null
  
)

export default component.exports